export default {
    type: 'widget',
    config: {
        defaultWidth: 80,
        icon: 'weight-hanging',
        demotable: true
    },
    default: {},
    unique: [],
    sort: 'weight',
    lang: {
        name: 'Weight',
        views: ['list', 'sheet', 'grid'],
        category: 'BGG',
        description: 'Community average complexity rating of the game.',
    },
    filters: ['bgg.weight']
}